module.exports = "/images/ring.svg?664590adfee106aa2f4a59d0798b9a92";